import { ChainSettingsFormValues } from './types';

export const hasRequiredFields = (values: ChainSettingsFormValues): boolean => {
  return true;
};
